module.exports = __webpack_public_path__ + "static/team-image-2-06214f4f97e4967fc2605f4384a98fb9.png";